import React from "react";
export var tooltipFallback = function () {
    return (React.createElement("div", { className: "form__tooltip" },
        React.createElement("svg", null,
            React.createElement("use", { xlinkHref: "#icon--info" }))));
};
